import { isNullOrWhitespace, setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";
import { DotLegalSelectOption } from "../../../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface CustomSingleSelectFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    value: string;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomSingleSelectField(props: CustomSingleSelectFieldProps) {
    const { translateString } = useTranslation();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    const url = `/settings/input-fields/${props.customInputFieldId}/select-options`;
    const { isLoading, data } = useDotLegalQuery<Array<DotLegalSelectOption>>(url, {
        enabled: !props.isPreview,
    });

    return (
        <DotLegalSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            isLoading={props.isLoading || isLoading}
            options={data ?? []}
            onChange={props.readOnly ? () => {} : (value) => onFieldChange(value)}
            label={props.fieldName!}
            toolTipText={props.fieldDescription}
            noOptionsLabel={translateString("noOptions")}
            selectedItem={props.value as string}
            disabled={props.isDisabled}
            errorText={!isNullOrWhitespace(props.errorText) && !props.isPreview ? props.errorText : undefined}
            helperText={
                props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.SingleDropDown].toString())) : undefined
            }
        />
    );
}

export default CustomSingleSelectField;
